import { navLinks } from "@/mocks/content";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-flashlight-fill"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-black text-xl tracking-wide text-background-50">快猫</span>
                <span className="text-[10px] tracking-[0.25em] text-secondary-300">KUAIMAO</span>
              </span>
            </div>
            <p className="mt-5 text-sm text-secondary-100/90 leading-relaxed max-w-md">
              本站是快猫平台内容生态的导航与说明页，集中介绍直播分区、热门主播风格、短视频题材、福利内容观看方式，
              以及 VIP 权限与深夜档差异，帮助你更快找到感兴趣的内容类型。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["快猫", "快猫直播", "快猫短视频", "快猫VIP", "快猫深夜"].map((k) => (
                <span key={k} className="text-[11px] text-secondary-100 bg-white/10 px-2.5 py-1 rounded-full">
                  {k}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading font-bold text-background-50 text-sm tracking-wide">页面分区</h3>
            <nav className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
              {navLinks.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  className="text-sm text-secondary-100/85 hover:text-accent-300 cursor-pointer transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading font-bold text-background-50 text-sm tracking-wide">提示</h3>
            <ul className="mt-4 space-y-3 text-sm text-secondary-100/85 leading-relaxed">
              <li className="flex items-start gap-2">
                <i className="ri-information-line text-accent-300 mt-0.5"></i>
                本页仅为内容导航说明，具体开放范围以平台内实际显示为准。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-accent-300 mt-0.5"></i>
                深夜档时间为常见规律，可能随平台调整变化。
              </li>
            </ul>
            <a
              href="#top"
              className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 cursor-pointer transition-colors"
            >
              <i className="ri-arrow-up-line"></i>
              回到顶部
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-200/80">© {year} 快猫内容导航 · 本页内容仅供了解与参考</p>
          <p className="text-xs text-secondary-200/80">主播 · 短视频 · 福利 · VIP · 深夜档 全解析</p>
        </div>
      </div>
    </footer>
  );
}